import templateUrl from './discarded-identifiers.html';
import _ from 'lodash';

export const discardedIdentifiers = {
    templateUrl,

    bindings: {
        seller: '<', // Les données du fournisseur.
    },
    controllerAs: 'vm',
    controller: class DiscardedIdentifiers {
        /*@ngInject*/
        constructor($translate, $uibModal, logger, KissSellerSvc) {
            this.$translate = $translate;
            this.$uibModal = $uibModal;
            this.logger = logger;
            this.KissSellerSvc = KissSellerSvc;
            this.gridApi = null;
        }

        $onInit() {
            var discardedIdentifiersData = {};
            var defaultCellTemplate =
                '<div  class="ui-grid-cell-contents cursor-default">{{COL_FIELD CUSTOM_FILTERS}}</div>';
            var deleteCellTemplate =
                '<div class="ui-grid-cell-contents cursor-default text-center" name="discarded_Identifier_del"' +
                'ng-disabled="!grid.appScope.vm.canDeleteIdentifier()" ng-click="!grid.appScope.vm.canDeleteIdentifier() || grid.appScope.vm.openRemoveConfirmationModal(row.entity)">' +
                '<span><i class="fa fa-trash"></i></span>&nbsp;</div>';

            this.discardedIdentifiersGridOptions = {
                columnDefs: [
                    {
                        name: 'getIdFiscalKindLabel()',
                        displayName: 'kiss_seller.edit.discarded_identifiers.id_fiscal_kind',
                        headerCellFilter: 'translate',
                        width: '350',
                        cellFilter: 'translate',
                        cellTemplate: defaultCellTemplate,
                        cellClass: 'pointer cursor-default',
                    },
                    {
                        name: 'idFiscal',
                        displayName: 'kiss_seller.edit.discarded_identifiers.id_fiscal',
                        headerCellFilter: 'translate',
                        minWidth: '150',
                        cellTemplate: defaultCellTemplate,
                        cellClass: 'pointer cursor-default',
                        sort: { direction: 'asc', priority: 0 },
                    },
                    {
                        name: 'discardDate',
                        displayName: 'kiss_seller.edit.discarded_identifiers.discard_date',
                        headerCellFilter: 'translate',
                        headerCellClass: 'text-center',
                        cellFilter: 'date:"shortDate"',
                        filterCellFiltered: true,
                        width: '180',
                        cellTemplate: defaultCellTemplate,
                        cellClass: 'pointer cursor-default text-center',
                    },
                    {
                        name: 'delete',
                        displayName: '',
                        enableCellEdit: true,
                        width: '50',
                        cellTemplate: deleteCellTemplate,
                        cellClass: 'pointer cursor-default',
                        enableSorting: false,
                    },
                ],
                useExternalPagination: false,
                useExternalSorting: false,
                onRegisterApi: gridApi => this.onRegisterApi(gridApi),
                enableSorting: true,
                enableGridMenu: false,
                enableRowSelection: false,
                enableColumnMenus: false,
                data: discardedIdentifiersData,
            };

            this.search();
        }

        onRegisterApi(gridApi) {
            this.gridApi = gridApi;
        }

        getDiscardedIdentifiersGridHeight() {
            var rowHeight = 30;
            return {
                height: this.gridApi.core.getVisibleRows(this.gridApi.grid).length * rowHeight + 81 + 'px',
            };
        }

        /**
         * Lance la recherche des identifiants fiscaux rejetés.
         */
        search() {
            const idSearch = this.seller.isBuyer() && this.seller.biProfil ? this.seller.idBiProfil : this.seller.id;
            this.discardedIdentifiersGridOptions.data = this.KissSellerSvc.getDiscardedIdentifiers(idSearch).then(
                identifiers => {
                    this.discardedIdentifiersGridOptions.data = identifiers;
                }
            );
        }

        /**
         * Nous dit si les identifiants fiscaux rejetés par le fournisseur peuvent être supprimés.
         */
        canDeleteIdentifier() {
            return this.seller.legalEntity.idFiscal === null;
        }

        // Popup de confiramtion pour la suppression d'un identifiant fiscal rejeté par le fournisseur.
        openRemoveConfirmationModal(identifierToDelete) {
            this.$uibModal
                .open({
                    component: 'confirmationModal',
                    size: 'md',
                    resolve: {
                        modalTitle: () => {
                            return { value: 'kiss_seller.edit.discarded_identifiers.title' };
                        },
                        modalMessage: () => {
                            return [
                                {
                                    key: 'kiss_seller.edit.discarded_identifiers.delete_confirmation',
                                    values: { idFiscal: identifierToDelete.idFiscal },
                                },
                            ];
                        },
                        modalCancelButtonText: () => {
                            return { value: 'commons.cancel' };
                        },
                        modalConfirmButtonText: () => {
                            return { value: 'commons.confirm' };
                        },
                        data: function () {
                            return {};
                        },
                    },
                    backdrop: 'static',
                    keyboard: false,
                })
                .result.then(
                    () => {
                        this.KissSellerSvc.deleteDiscardedIdentifier(this.seller.id, identifierToDelete.id).then(() => {
                            _.remove(
                                this.discardedIdentifiersGridOptions.data,
                                data => data.id === identifierToDelete.id
                            );
                        });
                    },
                    () => {}
                );
        }
    },
};
